package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.Serializable
import kotlin.collections.AbstractList

/** Common envelope returned by paginated/list REST endpoints. */
@Serializable
data class RecordListResponse<T>(
    val count: Int,
    val items: List<T>
)

/** List-compatible view that keeps the server total available after unwrapping. */
class RecordListItems<T>(
    private val values: List<T>,
    val totalCount: Int
) : AbstractList<T>() {
    override val size: Int get() = values.size
    override fun get(index: Int): T = values[index]
}

fun <T> List<T>.serverTotalCountOrNull(): Int? =
    (this as? RecordListItems<*>)?.totalCount

fun <T> List<T>.withServerTotalCount(totalCount: Int?): List<T> =
    totalCount?.let { RecordListItems(this, it) } ?: this
